import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import { ScaffolderInputHeader } from '../../../components';
import { NAMESPACE_INFO } from '../infoDoc';
import { useStyles } from '../styles';

export interface NamespaceInputProps {
  formData: string[];
  onChange: (data: string[]) => void;
  rawErrors: string[];
  maxNamespaces?: number;
  disabled?: boolean;
}

export const NamespaceInput = (props: NamespaceInputProps) => {
  const {
    onChange,
    formData,
    rawErrors,
    maxNamespaces = 10,
    disabled = false,
  } = props;
  const { classes } = useStyles();

  const handleAddNamespace = () => {
    onChange([...formData, '']);
  };

  const handleNamespaceChange = (index: number, value: string) => {
    onChange(formData.map((namespace, i) => (i === index ? value : namespace)));
  };

  const handleRemoveNamespace = (index: number) => {
    onChange(formData.filter((_, i) => i !== index));
  };

  const canAddNamespace = formData.length < maxNamespaces;

  return (
    <Box>
      <ScaffolderInputHeader
        title="Namespaces"
        description="List of namespaces allowed to use for deploying applications to the cluster."
        infoDoc={NAMESPACE_INFO}
      />
      {formData.map((namespace, index) => (
        <Box key={index} className={classes.flexContainer}>
          <Box className={classes.inputContainer}>
            <TextField
              label="Namespace"
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter namespace or namespace pattern, e.g. dev-*"
              required
              value={namespace}
              onChange={e => handleNamespaceChange(index, e.target.value)}
              disabled={disabled}
              error={Boolean(rawErrors?.length) && formData.length === 0}
            />
          </Box>
          <Box marginBottom={2}>
            <Button
              variant="outlined"
							disabled={disabled}
              color="secondary"
              onClick={() => handleRemoveNamespace(index)}
            >
              Remove
            </Button>
          </Box>
        </Box>
      ))}
      <Button
        startIcon={<AddIcon />}
				onClick={handleAddNamespace}
        color="secondary"
        disabled={disabled || !canAddNamespace}
      >
        Add Namespace
      </Button>
    </Box>
  );
};
